(function() {
  const blockedUrls = [
    '/collections/best-sellers/products/exfoliating-peel-cleanser',
    '/collections/best-sellers/products/gray-gaurd-beard-illuminating-serum',
    '/collections/face-wash/products/anti-acne-face-wash',
    '/collections/face-wash/products/anti-pollution-face-wash',
    '/collections/skin-care/products/sunscreen-spf-50-for-men',
    '/collections/skin-care/products/skin-tint-moisturizer',
    '/collections/skin-care/products/hydro-booster-gel',
    '/collections/skin-care/products/hydroblast-toning-mist',
    '/collections/hair-care/hair-removal-spray',
    '/collections/hair-care/hair-growth-nourishing-oil',
    '/collections/hair-care/hair-styling-wax-powder',
    '/collections/best-sellers/products/hair-removal-spray',
    '/collections/best-sellers/products/hair-growth-nourishing-oil',
    '/collections/best-sellers/products/sunscreen-spf-50-for-men',
    '/collections/best-sellers/products/hydro-booster-gel',
    '/collections/best-sellers/products/hydroblast-toning-mist',
    '/collections/best-sellers/products/hair-styling-wax-powder',
    '/collections/combo/products/exfoliating-peel-cleanser',
    '/collections/combo/products/anti-pollution-face-wash',
    '/collections/combo/products/gray-gaurd-beard-illuminating-serum',
    '/collections/combo/products/anti-acne-face-wash',
    '/collections/beard-care/products/anti-acne-face-wash',
    '/collections/beard-care/products/exfoliating-peel-cleanser',
    '/collections/beard-care/products/anti-pollution-face-wash',
    '/collections/combo/products/',
    '/collections/beard-care/products/',
    '/blogs/news/tagged/glow-up',
    '/collections/beard-care/products/gray-gaurd-beard-illuminating-serum',
    '/collections/skin-care/products/anti-acne-face-wash',
    '/collections/skin-care/products/anti-pollution-face-wash',
    '/collections/skin-care/products/exfoliating-peel-cleanser',
    '/collections/best-sellers/products/anti-acne-face-wash',
    '/collections/face-wash/products/gray-gaurd-beard-illuminating-serum',
    '/collections/face-wash/products/exfoliating-peel-cleanser',
    '/collections/hair-care/products/gray-gaurd-beard-illuminating-serum',
    '/collections/hair-care/anti-acne-face-wash',
    '/collections/hair-care/products/exfoliating-peel-cleanser',
    '/collections/hair-care/products/anti-pollution-face-wash',
    '/blogs/news/tagged/anti-acne-solutions',
    '/collections/cart-recommendation-collection',
    '/collections/face-mist',
    '/collections/face-moisturiser',
    '/collections/best-sellers/products/anti-pollution-face-wash'
  ];

  const currentPath = window.location.pathname;
  if (blockedUrls.includes(currentPath)) {
    window.location.href = '/404';
  }
})();
